
const getEnv = () => {
    return {
        API_ENDPOINT_URL: 'https://apitest.tunimobile.com/v1/',
        IMG_SRC: 'https://apitest.tunimobile.com',
        NOVU_APP_ID: 'gIJdfzDMyVEF',
        WEB_SOCKET_URL: 'wss://apitest.tunimobile.com/ws'
    };
};

export const env = getEnv();
